import { forwardRef, type HTMLAttributes } from "react"
import { twMerge } from "tailwind-merge"

export const Body = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={twMerge("flex flex-col gap-4 tt-modal-body", className)}
        {...props}
      />
    )
  }
)
Body.displayName = "Body"

export const ButtonGroup = (props: HTMLAttributes<HTMLDivElement>) => {
  return <div className="flex gap-2" {...props} />
}

export const Footer = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={twMerge("flex items-center tt-modal-footer", className)}
      {...props}
    />
  )
}
